import { Base64 } from 'js-base64';
const LINK_PREFIX = 'l';
const GUEST_LINK_PREFIX = 'g';
const LINK_SEPARATOR = '/';
export const decode = (link) => {
    const urlParams = new URLSearchParams(link.search);
    const linkPath = urlParams.get('linkPath');
    if (linkPath == null) {
        throw new InvalidLinkError('Missing linkPath param');
    }
    const [linkPrefix, linkVersion, ...linkComponents] = linkPath
        .slice(1)
        .split(LINK_SEPARATOR);
    if (linkPrefix !== LINK_PREFIX && linkPrefix !== GUEST_LINK_PREFIX) {
        throw new InvalidLinkError('Invalid linkPath param');
    }
    if (linkVersion === '1') {
        return decodeDirectLinkV1(linkComponents);
    }
    throw new InvalidLinkError('Unsupported version format');
};
export const decodeDirectLinkV1 = (linkComponents) => {
    if (!linkComponents || linkComponents.length != 2) {
        throw new InvalidLinkError('Malformed link');
    }
    const [paramsBase64, fileName] = linkComponents;
    if (typeof paramsBase64 !== 'string' ||
        paramsBase64 === '' ||
        !Base64.isValid(paramsBase64)) {
        throw new InvalidLinkError('Malformed params');
    }
    if (typeof fileName !== 'string' || fileName === '') {
        throw new InvalidLinkError('Missing filename');
    }
    const params = Base64.decode(paramsBase64).split(LINK_SEPARATOR);
    if (params.length != 4) {
        throw new InvalidLinkError('Missing params');
    }
    return {
        workspaceId: params[0],
        filespaceId: params[1],
        parentEntryId: params[2],
        entryId: params[3],
        fileName: fileName,
    };
};
export class InvalidLinkError extends Error {
    constructor(message) {
        super('Invalid link: ' + message);
    }
}
